<template>
  <Complaint :value="value" />
</template>
<script>
import Complaint from '@/components/Task/Complaint/Component'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    Complaint,
  },
}
</script>
